"use client"

import { getHex } from "@/theme"
import { AppProgressBar as NextProgressBar } from "next-nprogress-bar"

const color = getHex("primary-3")

export const ProgressBar = () => {
  return <NextProgressBar height="4px" color={color} options={{ showSpinner: false }} shallowRouting />
}
